export default __webpack_public_path__ + "static/media/rice03.39213af1.png";